import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePages } from '../hooks/usePages';

interface Page {
  id: string;
  title: string;
  icon: string | null;
  parent_id: string | null;
}

export function Sidebar() {
  const { pages, loading, createPage } = usePages();
  const navigate = useNavigate();

  const handleCreatePage = async () => {
    const newPage = await createPage({ title: 'Untitled' });
    if (newPage) {
      navigate(`/page/${newPage.id}`);
    }
  };

  // Build tree structure
  const rootPages = pages.filter((p) => !p.parent_id);

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>BB Docs</h2>
        <button onClick={handleCreatePage} className="btn-new-page">
          +
        </button>
      </div>

      <nav className="sidebar-nav">
        {loading ? (
          <div className="loading">Loading...</div>
        ) : (
          <PageList pages={rootPages} allPages={pages} />
        )}
      </nav>
    </aside>
  );
}

function PageList({ pages, allPages }: { pages: Page[]; allPages: Page[] }) {
  return (
    <ul className="page-list">
      {pages.map((page) => (
        <PageItem key={page.id} page={page} allPages={allPages} />
      ))}
    </ul>
  );
}

function PageItem({ page, allPages }: { page: Page; allPages: Page[] }) {
  const [expanded, setExpanded] = useState(true);
  const children = allPages.filter((p) => p.parent_id === page.id);
  const hasChildren = children.length > 0;

  return (
    <li className="page-item">
      <div className="page-link-row">
        {hasChildren && (
          <button
            className="expand-btn"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? '▼' : '▶'}
          </button>
        )}
        <Link to={`/page/${page.id}`} className="page-link">
          <span className="page-icon">{page.icon || '📄'}</span>
          <span className="page-title">{page.title}</span>
        </Link>
      </div>
      {hasChildren && expanded && (
        <PageList pages={children} allPages={allPages} />
      )}
    </li>
  );
}
